@if (products.length > 0 && layout === 'carousel') {
  <!-- Accueil mobile : carrousel horizontal, classement 1, 2, 3… -->
  <section class="hot-carousel" [attr.aria-label]="'deals.hotDeals' | t">
    <h2 class="hot-carousel-title">
      <mat-icon aria-hidden="true">local_fire_department</mat-icon>{{ 'deals.hotDeals' | t }}
    </h2>
    <div class="hot-carousel-track">
      @for (product of products; track product._id; let rank = $index) {
        <a class="hot-card" [routerLink]="['/product', product._id]">
          <span class="hot-card-media">
            @if (product.pictureUrl) {
              <img [src]="product.pictureUrl" alt="" [appImgFallback]="product.storedPictureUrl" loading="lazy">
            }
            <span class="hot-card-rank">{{ rank + 1 }}</span>
          </span>
          <span class="hot-card-info">
            <span class="hot-card-merchant">{{ product.advertiserName }}</span>
            <span class="hot-card-name">{{ product.name }}</span>
            <span class="hot-card-bottom">
              @if (product.priceDiscount) {
                <span class="hot-card-price">{{ product.priceDiscount }}€</span>
              }
              <span class="hot-card-score">
                <mat-icon aria-hidden="true">local_fire_department</mat-icon>{{ product.voteScore || 0 }}°
              </span>
            </span>
          </span>
        </a>
      }
    </div>
  </section>
}
@if (products.length > 0 && layout === 'list') {
  <div class="hot-deals-sidebar">
    <div class="hot-deals-header">
      <span>{{ 'deals.hotDeals' | t }}</span>
    </div>
    @for (product of products; track product) {
      <div class="hot-deal-item" (click)="onDetails(product)">
        <span class="hot-deal-score" [ngClass]="'hot-deal-score-' + getVoteLevel(product)">
          <mat-icon class="hot-deal-fire">local_fire_department</mat-icon>{{product.voteScore || 0}}°
        </span>
        @if (product.pictureUrl) {
          <img class="hot-deal-thumb" [src]="product.pictureUrl" [alt]="product.name" [appImgFallback]="product.storedPictureUrl">
        }
        <div class="hot-deal-info">
          <span class="hot-deal-name">{{product.name | slice:0:50 }} </span>
          <div class="hot-deal-price-row">
            @if (product.priceDiscount) {
              <span class="hot-deal-price">{{product.priceDiscount}}€</span>
            }
            @if (product.price && product.price != product.priceDiscount) {
              <span class="hot-deal-old-price">{{product.price | number: '1.2-2'}}€</span>
            }
            @if (product.percentageDiscount) {
              <span class="hot-deal-discount">{{product.percentageDiscount}}%</span>
            }
          </div>
        </div>
      </div>
    }
  </div>
}
